import {
    isInPlugin
} from "./isInPlugin";

export const showSubscribePrompt = async (appId, options = {}) => {
    // Check if plugin is activated and also if current page is belong to the plugin
    // then ask the user to subscribe to webpush (show webpush dialog)
    if (isInPlugin(window.location.href)) {
        if (window.hasOwnProperty('BestPush') && window.hasOwnProperty('BestPushOptions')) {
            window.BestPush.init(appId);
            window.BestPush.subscribe({...window.BestPushOptions, ...options});
        }
    }
}